import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Image, Modal, Row } from 'react-bootstrap'
import LandingHeaderDownload from './LandingHeaderDownload';
import axios from 'axios';
import LandingPageHeader from './LandingPageHeader';
export default function LandingPage3() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    useEffect(() => {
        //storeAppDownloads
        uploadAppDownloadData(0)
    }, [])
    const uploadAppDownloadData = async (btn_pressed) => {
        const data = {
            page_name: 'landingpage3',
            app_version: '1.3',
            is_download_btn_clicked: btn_pressed
        }
        await axios.post(`${process.env.REACT_APP_API_URL}/storeAppDownloads`, data)
            .then((response) => {
                console.log(response);
            })
    }
    return (
        <>
            <Row justify="center" className='landingpage_main'>
                <Col span={4}>
                    {/* <LandingHeaderDownload /> */}
                    <LandingPageHeader />
                    <Container style={{ marginTop: "19%" }}>
                    <Image
                            src={`${process.env.PUBLIC_URL}/landing_page_image/landingpage3_1.png`}
                            style={{
                                width: "100%",
                                objectFit: "fill"
                            }}
                        />
                    <a download={true} href={`${process.env.PUBLIC_URL}/apks/app-releasev1_3.apk`}
                            onClick={() => {
                                handleShow();
                                uploadAppDownloadData(1)
                            }}
                           >
                        <Image
                            src={`${process.env.PUBLIC_URL}/landing_page_image/landingpage3_2.png`}
                            style={{
                                width: "100%",
                                objectFit: "fill"
                            }}
                        />
                         </a>
                        <Row>
                      
                        </Row>
                       
                    </Container>
                </Col>
            </Row>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header>
                    <div onClick={handleClose} style={{ textAlign: 'right' }}>X</div>
                </Modal.Header>
                <Modal.Body>
                    <Image
                        src={`${process.env.PUBLIC_URL}/images/download _warning.jpg`}
                        style={{ width: "100%" }}
                    />
                </Modal.Body>
            </Modal>
        </>
    )
}
